import React from 'react';

const RiseIcon = () => (
  <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.3421 0.571429C7.3421 0.255837 7.58717 0 7.88947 0H12.6789C13.1324 0 13.5 0.383756 13.5 0.857143V6C13.5 6.31559 13.2549 6.57143 12.9526 6.57143C12.6503 6.57143 12.4053 6.31559 12.4053 6V1.89718L8.04298 6.09168C7.71909 6.40311 7.21753 6.39236 6.90617 6.06731L5.01579 4.09384L1.43442 7.83263C1.22066 8.05579 0.874081 8.05579 0.660321 7.83263C0.44656 7.60948 0.44656 7.24767 0.660321 7.02451L4.43522 3.08368C4.75586 2.74895 5.27572 2.74895 5.59636 3.08368L7.49453 5.06529L11.5739 1.14286H7.88947C7.58717 1.14286 7.3421 0.88702 7.3421 0.571429Z"
      fill="currentColor"
    />
  </svg>
);

export default RiseIcon;
